function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_7154_6147)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.67533 13.6498C4.60938 9.85938 9.0575 5.37769 16.1719 5.37769C23.3061 5.37769 27.7031 9.62501 29.6289 13.6893C30.1533 14.5403 30.1731 15.5595 29.6684 16.4203C27.1651 20.7444 23.2863 24.6924 16.1719 24.6924C15.2251 24.6924 14.2938 24.651 13.4424 24.5301C12.9823 24.4647 12.5085 24.5229 12.0996 24.7437C10.9454 25.367 9.78477 26.0431 8.30549 26.8792C7.85033 27.1364 7.29622 26.7901 7.3259 26.2657L7.54231 22.8572C7.5744 22.3516 7.34549 21.8682 6.95798 21.542C5.22876 20.0861 3.87285 18.2536 2.71491 16.3708C2.19048 15.5199 2.17069 14.5106 2.67533 13.6498Z",
  fill: "url(#paint0_radial_7154_6147)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.67533 13.6498C4.60938 9.85938 9.0575 5.37769 16.1719 5.37769C23.3061 5.37769 27.7031 9.62501 29.6289 13.6893C30.1533 14.5403 30.1731 15.5595 29.6684 16.4203C27.1651 20.7444 23.2863 24.6924 16.1719 24.6924C15.2251 24.6924 14.2938 24.651 13.4424 24.5301C12.9823 24.4647 12.5085 24.5229 12.0996 24.7437C10.9454 25.367 9.78477 26.0431 8.30549 26.8792C7.85033 27.1364 7.29622 26.7901 7.3259 26.2657L7.54231 22.8572C7.5744 22.3516 7.34549 21.8682 6.95798 21.542C5.22876 20.0861 3.87285 18.2536 2.71491 16.3708C2.19048 15.5199 2.17069 14.5106 2.67533 13.6498Z",
  fill: "url(#paint1_radial_7154_6147)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.67533 13.6498C4.60938 9.85938 9.0575 5.37769 16.1719 5.37769C23.3061 5.37769 27.7031 9.62501 29.6289 13.6893C30.1533 14.5403 30.1731 15.5595 29.6684 16.4203C27.1651 20.7444 23.2863 24.6924 16.1719 24.6924C15.2251 24.6924 14.2938 24.651 13.4424 24.5301C12.9823 24.4647 12.5085 24.5229 12.0996 24.7437C10.9454 25.367 9.78477 26.0431 8.30549 26.8792C7.85033 27.1364 7.29622 26.7901 7.3259 26.2657L7.54231 22.8572C7.5744 22.3516 7.34549 21.8682 6.95798 21.542C5.22876 20.0861 3.87285 18.2536 2.71491 16.3708C2.19048 15.5199 2.17069 14.5106 2.67533 13.6498Z",
  fill: "url(#paint2_radial_7154_6147)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.67533 13.6498C4.60938 9.85938 9.0575 5.37769 16.1719 5.37769C23.3061 5.37769 27.7031 9.62501 29.6289 13.6893C30.1533 14.5403 30.1731 15.5595 29.6684 16.4203C27.1651 20.7444 23.2863 24.6924 16.1719 24.6924C15.2251 24.6924 14.2938 24.651 13.4424 24.5301C12.9823 24.4647 12.5085 24.5229 12.0996 24.7437C10.9454 25.367 9.78477 26.0431 8.30549 26.8792C7.85033 27.1364 7.29622 26.7901 7.3259 26.2657L7.54231 22.8572C7.5744 22.3516 7.34549 21.8682 6.95798 21.542C5.22876 20.0861 3.87285 18.2536 2.71491 16.3708C2.19048 15.5199 2.17069 14.5106 2.67533 13.6498Z",
  fill: "url(#paint3_radial_7154_6147)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.67533 13.6498C4.60938 9.85938 9.0575 5.37769 16.1719 5.37769C23.3061 5.37769 27.7031 9.62501 29.6289 13.6893C30.1533 14.5403 30.1731 15.5595 29.6684 16.4203C27.1651 20.7444 23.2863 24.6924 16.1719 24.6924C15.2251 24.6924 14.2938 24.651 13.4424 24.5301C12.9823 24.4647 12.5085 24.5229 12.0996 24.7437C10.9454 25.367 9.78477 26.0431 8.30549 26.8792C7.85033 27.1364 7.29622 26.7901 7.3259 26.2657L7.54231 22.8572C7.5744 22.3516 7.34549 21.8682 6.95798 21.542C5.22876 20.0861 3.87285 18.2536 2.71491 16.3708C2.19048 15.5199 2.17069 14.5106 2.67533 13.6498Z",
  fill: "url(#paint4_radial_7154_6147)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_7154_6147)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.73791 21.1167L8.15383 25.6225C8.12716 25.8282 8.34814 25.975 8.52744 25.8707L12.4485 23.5904L11.1807 21.3331L8.73791 21.1167Z",
  fill: "url(#paint5_linear_7154_6147)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_7154_6147)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.1719,
  cy: 16.172,
  rx: 8.71983,
  ry: 5.68953,
  fill: "#DBD1F0",
  fillOpacity: 0.5
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_7154_6147",
  x: 2.3089,
  y: 5.37769,
  width: 27.726,
  height: 21.5984,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.01
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 0 0.758333 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_7154_6147"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_7154_6147",
  x: 7.15163,
  y: 20.1167,
  width: 6.29684,
  height: 6.78857,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur_7154_6147"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_7154_6147",
  x: 2.45203,
  y: 5.48242,
  width: 27.4397,
  height: 21.3792,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  result: "effect1_foregroundBlur_7154_6147"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_7154_6147",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.0881 6.7073) rotate(108.693) scale(17.3662 42.1894)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D7C6DE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_7154_6147",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.5853 22.57) rotate(-118.35) scale(19.5353 28.2519)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.618897,
  stopColor: "#CECECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CECECE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_7154_6147",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.6644 23.4358) rotate(-171.015) scale(29.302 42.3765)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.781471,
  stopColor: "#CECECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CECECE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_7154_6147",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.0801 24.6726) rotate(-38.5812) scale(28.1634 40.7298)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.644692,
  stopColor: "#CECECE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CECECE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_7154_6147",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.4196 8.34614) rotate(81.1703) scale(25.7848 28.6826)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.464136,
  stopColor: "#B6A8F2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B6A8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_7154_6147",
  x1: 10.2685,
  y1: 26.4043,
  x2: 13.1906,
  y2: 20.9312,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCD0F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DED0F9",
  stopOpacity: 0
})));

function SvgSpeechBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBalloon);
export default __webpack_public_path__ + "static/media/speech-balloon.8cc43162.svg";
export { ForwardRef as ReactComponent };